import * as React from 'react'
import { useCallback } from 'react'
import { DateRangeFilter, IFilterMode, IOption } from '@user/components/Filters'
import {
  MultiSelectFilter,
  MultiSelectTidalFilter,
} from '@user/components/Filters/components/MultiSelectFilter'
import { SalesTeamProvider } from '@user/components/Leads/LeadFilters/SalesTeamProvider'
import { SalesFunnelFilterSet } from '@user/store/salesFunnelSummary/filters'
import { useFormikContext } from 'formik'
import { AssigneeProvider } from '@user/components/Leads/LeadFilters/AssigneeProvider'
import { LeadTypeProvider } from '@user/components/Leads/LeadFilters'

export const SalesFunnelFilters: React.FC<IFilterMode> = (props) => {
  const isOptionEqual = useCallback(
    (optionA: IOption, optionB: IOption) => optionA.value === optionB.value,
    [],
  )

  const {
    values: {
      filters: {
        salesTeamIds: { value: salesTeamIds },
      },
    },
  } = useFormikContext<SalesFunnelFilterSet>()
  const { reset } = props

  return (
    <>
      <DateRangeFilter name="createdDate" label="Date Range" />
      <MultiSelectTidalFilter
        name="salesTeamIds"
        label="Sales Team"
        component={SalesTeamProvider}
        isOptionEqual={isOptionEqual}
        hideCheckBox={false}
      />
      <MultiSelectTidalFilter
        name="ownerIds"
        label="Owner"
        component={AssigneeProvider}
        isOptionEqual={isOptionEqual}
        hideCheckBox={false}
        reset={reset}
        dependsOn={salesTeamIds.options}
      />
      <MultiSelectFilter
        name="type"
        label="Type"
        component={LeadTypeProvider}
        reset={reset}
      />
      {/* Hidden until we can align this filter with the "Sales Funnel" filter on Lead/Opp pages */}
      {/* <MultiSelectFilter
        name="salesFunnelIds"
        label="Sales Funnels"
        component={SalesFunnelProvider}
        hideModeSelect
      /> */}
    </>
  )
}

SalesFunnelFilters.displayName = 'SalesFunnelFilters'
